import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IAuthState {
  user: any;
  token: string;
  isLoggedIn: boolean;
}

export const initialState: IAuthState = {
  isLoggedIn: false,
  token: "",
  user: null,
};

const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<{ token: string }>) => {
      state.token = action.payload.token;
      state.isLoggedIn = true;
    },
    logout: (state) => {
      state.token = "";
      state.user = null;
      state.isLoggedIn = false;
    },
    setUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
    },
  },
});

const { actions, reducer } = authSlice;
export const { login, logout, setUser } = actions;

export default reducer;
